import { isEmpty } from "lodash";
import { defaultRssSetting } from "../../../config/constants";
import { FLIP_CLOCK_SETTINGS } from "../../../Constants/clock";

const appsActions = {
    setCreateDialog: (state, action) => { state.createDialog = action.payload; },
    setPrayerEnableDialog: (state, action) => { state.prayerEnableDialog = action.payload; },
    setIsLoading: (state, action) => { state.isLoading = action.payload; },
    setData: (state, action) => { state.data = action.payload; },

    setSelectedFeed: (state, action) => { state.selectedFeed = action.payload; },
    setSelectedRss: (state, action) => { state.selectedRss = action.payload },
    setIsCreation: (state, action) => { state.isCreation = action.payload; },
    setNewSeparator: (state, action) => { state.newSeparator = action.payload; },
    setRssName: (state, action) => { state.rssName = action.payload; },
    setWeatherData: (state, action) => { state.weatherData = action.payload; },
    setIsEditingWeather: (state, action) => { state.isEditingWeather = action.payload; },
    setWeatherTextColor: (state, action) => { state.weatherTextColor = action.payload; },
    setWeatherBgColor: (state, action) => { state.weatherBgColor = action.payload; },
    setWeatherCardColor: (state, action) => { state.weatherCardColor = action.payload; },
    resetWeatherStates:(state)=>{
        state.weatherData= {};
        state.isEditingWeather= false;
        state.weatherTextColor= "#f2f2f2ff";
        state.weatherBgColor="#3c5fb1";
        state.weatherCardColor= "rgba(255, 255, 255, 0.1)";
    },


    setClockSettings: (state, action) => {
        state.clockSettings = { ...state.clockSettings, ...action.payload };
    },
    setIsEditingClock: (state, action) => { state.isEditingClock = action.payload; },
    setClockData: (state, action) => { state.clockData = action.payload; },
    setClockDisplay: (state, action) => { state.clockDisplay = action.payload; },
    resetClockStates: (state) => {
        state.clockData = {};
        state.clockDisplay="FULL_SCREEN";
        state.clockSettings = FLIP_CLOCK_SETTINGS;
        state.isEditingClock = false;
    },

    setRssSettings: (state, action) => {
        state.rssSettings = { ...state.rssSettings, ...action.payload };
    },

    resetRssStates: (state) => {
        state.selectedRss = {};
        state.isCreation = true;
        state.rssSettings = defaultRssSetting;
        state.rssName = "Instance Name";
        state.selectedFeed = {};
    },

    rssDataHandler: (state, action) => {
        const { formData } = action.payload;

        let rss_settings = {
            ...defaultRssSetting,
            ...state.rssSettings,
            direction: state.rssSettings?.direction === "left" ? "ltr" : "rtl",
            duration: state.rssSettings?.duration ?? 20,
        };

        if (!isEmpty(state.rssSettings?.newSeparator)) {
            formData.append("separator", state.rssSettings?.newSeparator);
        }
        for (var key in rss_settings) {
            if (key !== "newSeparator" || !isEmpty(rss_settings?.newSeparator)) {
                formData.append(`rss_settings[${key}]`, rss_settings[key]);
            }
        }
    }


};

export default appsActions;
